module.exports = __webpack_public_path__ + "img/antes_despues_169.98b8b6ff.png";